import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';

export const progressBarCss = css({
  height: 2,
  width: '100%',
  backgroundColor: colorsPalette.grey20,
  marginBottom: 30,
  [MediaQueries.lgAndUp]: {
    height: 1,
  },
});

export const filledBarCss = css({
  backgroundColor: colorsPalette.grey,
});
